<template>
  <ejs-dialog
    ref="formDialog"
    id="integrations-form"
    class="dialog-papirus"
    target="#dialogIntegrations"
    :isModal="true"
    :visible="showing"
    :header="header"
    :width="width"
    :showCloseIcon="true"
    :close="onDialogClose"
    :open="onDialogOpen"
    z-index="1003"
  >
    <div id="integrationsToast"></div>
    <div class="col-lg-12 e-input-section">
      <div class="content-wrapper">
        <div class="row" v-show="showId">
          <div class="col-xs-12 col-sm-12 col-lg-2 col-md-2">
            <label class="e-text">Id Integración</label>
            <input
              id="id"
              class="e-input"
              v-model="m_data.id"
              type="text"
              disabled
              @blur="validateField('id')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-lg-6 col-md-6">
            <label class="e-text">Nombre Integración</label>
            <input
              id="name"
              class="e-input"
              :class="{ 'e-warning': hasError('name') }"
              type="text"
              required
              v-model="m_data.name"
              :readonly="isFormReadOnly"
              @input="validateField('name')"
              @blur="validateField('name')"
              placeholder="Nombre Integración"
            />
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('name') }"
              v-text="m_errors.name"
            >
            </span>
          </div>
          <div class="col-xs-12 col-sm-6 col-lg-6 col-md-6">
            <label class="e-text">Descripción Integración</label>
            <input
              id="description"
              class="e-input"
              :class="{ 'e-warning': hasError('description') }"
              type="text"
              required
              v-model="m_data.description"
              :readonly="isFormReadOnly"
              @input="validateField('description')"
              @blur="validateField('description')"
              placeholder="Descripción Integración"
            />
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('description') }"
              v-text="m_errors.description"
            >
            </span>
          </div>
        </div>
        <div class="row">
          <div
            class="col-xs-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-center"
          >
            <div class="align-self-stretch" style="width: 100%">
              <label class="e-text">Tipo de Integración</label>
              <ejs-dropdownlist
                ref="typesDropDown"
                id="typesDropDown"
                :dataSource="integrationTypes"
                :fields="integrationFields"
                v-model="m_data.integrationTypeId"
                :value="m_data.integrationTypeId"
                :readonly="isFormReadOnly"
                :showClearButton="true"
                :change="onIntegrationChange"
                placeholder="Tipo de Integración"
                width="100%"
              ></ejs-dropdownlist>
              <span
                class="help e-text small"
                :class="{ 'e-warning': hasError('integrationTypeId') }"
                v-text="m_errors.integrationTypeId"
              >
              </span>
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-6 col-lg-6 col-md-6 d-flex align-items-center"
          >
            <div>
              <ejs-switch
                cssClass="align-middle"
                id="isActive"
                v-model="m_data.isActive"
                :checked="m_data.isActive"
                :disabled="isFormReadOnly || !canDelete"
              ></ejs-switch>
              <label for="isActive" class="e-text align-middle switch-label">{{
                m_data.isActive ? "Activo" : "Inactivo"
              }}</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div
            class="col-xs-6 col-sm-6 col-lg-3 col-md-3 d-flex align-items-center"
          >
            <ejs-checkbox
              label="Es Email"
              :checked="m_data.isEmail"
              v-model="m_data.isEmail"
              disabled="true"
            ></ejs-checkbox>
          </div>
          <div
            class="col-xs-6 col-sm-6 col-lg-3 col-md-3 d-flex align-items-center"
          >
            <ejs-checkbox
              label="Es Sistema archivos"
              :checked="m_data.isFileSystem"
              v-model="m_data.isFileSystem"
              disabled="true"
            ></ejs-checkbox>
          </div>
          <div
            class="col-xs-6 col-sm-6 col-lg-3 col-md-3 d-flex align-items-center"
          >
            <ejs-checkbox
              label="Es FTP (SSH - SCP)"
              :checked="m_data.isSftp"
              v-model="m_data.isSftp"
              disabled="true"
            ></ejs-checkbox>
          </div>
          <div
            class="col-xs-6 col-sm-6 col-lg-3 col-md-3 d-flex align-items-center"
          >
            <ejs-checkbox
              label="Es Amazon S3"
              :checked="m_data.isS3Compatible"
              v-model="m_data.isS3Compatible"
              disabled="true"
            ></ejs-checkbox>
          </div>
        </div>
        <div class="row" v-show="m_data.useCustomNaming">
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <label class="e-text">Consulta Nombre Personalizado</label>
            <input
              id="namingSQLQuery"
              class="e-input"
              :class="{ 'e-warning': hasError('namingSQLQuery') }"
              type="text"
              required
              v-model="m_data.namingSQLQuery"
              :readonly="isFormReadOnly"
              @input="validateField('namingSQLQuery')"
              @blur="validateField('namingSQLQuery')"
              placeholder="Consulta Nombre Personalizado"
            />
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('namingSQLQuery') }"
              v-text="m_errors.namingSQLQuery"
            >
            </span>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <label class="e-text">Plantilla Nombre Personalizado</label>
            <input
              id="namingTemplate"
              class="e-input"
              :class="{ 'e-warning': hasError('namingTemplate') }"
              type="text"
              required
              v-model="m_data.namingTemplate"
              :readonly="isFormReadOnly"
              @input="validateField('namingTemplate')"
              @blur="validateField('namingTemplate')"
              placeholder="Consulta Nombre Personalizado"
            />
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('namingTemplate') }"
              v-text="m_errors.namingTemplate"
            >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <label class="e-text">Parámetros de Integración</label>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <ejs-grid
              ref="gridIntegrationItems"
              class="r-space"
              :actionBegin="onActionBegin"
              :actionComplete="onActionComplete"
              :toolbar="customToolbar"
              :toolbarClick="toolbar_click"
              :dataSource="gridData"
              locale="es-CO"
              :query="query"
              :allowSorting="false"
              :allowSelection="true"
              :allowExcelExport="false"
              :allowFiltering="false"
              :selectionSettings="selectionSettings"
              :allowPaging="true"
              :allowGrouping="false"
              :pageSettings="pageSettings"
              :editSettings="editSettings"
              :filterSettings="filterSettings"
              :columns="gridColumns"
            >
              <!-- <e-columns>
                <e-column
                  field="documentId"
                  headerText="Id Integración"
                  textAlign="Right"
                  :width="90"
                  :minWidth="90"
                  clipMode="Clip"
                  :visible="false"
                  defaultValue="0"
                ></e-column>
                <e-column
                  field="formatId"
                  headerText="Id Formato"
                  :isPrimaryKey="true"
                  textAlign="Right"
                  :width="90"
                  :minWidth="90"
                  clipMode="Clip"
                  :allowEditing="false"
                  :visible="true"
                  defaultValue="0"
                ></e-column>
                <e-column
                  field="name"
                  headerText="Nombre"
                  :allowFiltering="true"
                  :width="200"
                  :minWidth="200"
                  :allowEditing="false"
                  clipMode="EllipsisWithTooltip"
                ></e-column>
                <e-column
                  field="printOrder"
                  headerText="Orden"
                  :allowFiltering="true"
                  :width="90"
                  :minWidth="90"
                  :edit="intParams"
                  editType="numericedit"
                  :allowEditing="true"
                  clipMode="EllipsisWithTooltip"
                ></e-column>
                <e-column
                  field="isActive"
                  headerText="Activo"
                  :allowFiltering="false"
                  :width="90"
                  clipMode="EllipsisWithTooltip"
                  :required="true"
                  editType="booleanedit"
                  displayAsCheckBox="true"
                  :allowEditing="canDelete"
                ></e-column>
              </e-columns> -->
            </ejs-grid>
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('listaIntegrationItems') }"
              v-html="m_errors.listaIntegrationItems"
            >
            </span>
          </div>
        </div>
        <div class="row pull-right">
          <div class="col-xs-12 col-sm-12">
            <div class="e-btn-group">
              <ejs-button
                @click.native="validateForm"
                :isPrimary="true"
                iconCss="e-icons icon-save inline-command"
                cssClass="e-flat e-noback"
                v-if="showSaveButton"
                :disabled="disableButtons"
                >Grabar</ejs-button
              >
              <ejs-button
                :isDanger="true"
                iconCss="e-icons icon-trash inline-command"
                cssClass="e-flat e-danger e-noback"
                v-if="showDeleteButton"
                :disabled="disableButtons"
                >Desactivar
              </ejs-button>
              <ejs-button
                @click.native="close()"
                iconCss="e-icons icon-cancel inline-command"
                cssClass="e-flat e-noback"
                :disabled="disableButtons"
                >Cancelar</ejs-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </ejs-dialog>
</template>

<script>
import Vue from "vue";

import { FormActionEnum } from "../../services/enums.js";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
// import CultureMixin from "../../mixins/CultureMixin";

/* Plugins de Syncfusion */
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { SwitchPlugin } from "@syncfusion/ej2-vue-buttons";
import { CheckBoxPlugin } from "@syncfusion/ej2-vue-buttons";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";

import {
  GridPlugin,
  Edit,
  Filter,
  Page,
  Selection,
  CommandColumn,
  Toolbar,
  Sort
} from "@syncfusion/ej2-vue-grids";
import { Browser } from "@syncfusion/ej2-base";
/* Utilidades Syncfusion */
import {
  createSpinner,
  showSpinner,
  hideSpinner,
  Tooltip
} from "@syncfusion/ej2-popups";

/* Validación con YUP*/

import * as Yup from "yup";
import { es } from "yup-locales";
import { setLocale } from "yup";
setLocale(es);

Vue.use(GridPlugin);
Vue.use(DialogPlugin);
Vue.use(ButtonPlugin);
Vue.use(SwitchPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(TooltipPlugin);
Vue.use(DropDownListPlugin);

export default Vue.extend({
  mixins: [PermissionMixin, ToastMixin],
  computed: {
    showId() {
      return this.formAction !== FormActionEnum.ADD;
    },
    showSaveButton() {
      return (
        this.formAction === FormActionEnum.ADD ||
        this.formAction === FormActionEnum.EDIT
      );
    },
    showDeleteButton() {
      return this.formAction == FormActionEnum.DELETE;
    },
    customClass() {
      return {
        "dialog-papirus": true,
        "dialog-edit":
          this.formAction == FormActionEnum.ADD ||
          this.formAction == FormActionEnum.EDIT,
        "dialog-view": this.formAction == FormActionEnum.VIEW,
        "dialog-delete": this.formAction == FormActionEnum.DELETE
      };
    },
    isFormReadOnly() {
      var ret = false;

      switch (this.formAction) {
        case FormActionEnum.ADD:
          break;
        case FormActionEnum.EDIT:
          break;
        case FormActionEnum.VIEW:
          ret = true;
          break;
        case FormActionEnum.DELETE:
          ret = true;
          break;
      }
      return ret;
    },
    header() {
      if (this.formAction === FormActionEnum.ADD) {
        return "Nueva Integración";
      }
      if (this.formAction === FormActionEnum.VIEW) {
        return "Consultar Integración";
      }
      if (this.formAction === FormActionEnum.EDIT) {
        return "Modificar Integración";
      }
      if (this.formAction === FormActionEnum.DELETE) {
        return "Deshabilitar Integración";
      }
      return "";
    },
    canDelete() {
      if (!this.hasPermission("CanDelete")) {
        return false;
      }
      return true;
    },
    disableButtons() {
      return this.isSaving;
    },
    customToolbar() {
      //var canCreate = this.hasPermission("CanCreate");
      var canEdit = this.hasPermission("CanEdit");
      var toolbar = [];
      //if (canCreate) toolbar.push("Add");
      if (canEdit) toolbar.push("Edit");
      // if (canEdit) toolbar.push("Delete");
      toolbar.push("Update");
      toolbar.push("Cancel");
      return toolbar;
    },
    editSettings() {
      var canEdit = this.hasPermission("CanEdit");
      var canDelete = this.hasPermission("CanEdit");

      return {
        showDeleteConfirmDialog: true,
        allowEditing: canEdit,
        allowEditOnDblClick: false,
        allowAdding: false,
        allowDeleting: canDelete,
        mode: "Normal"
      };
    }
  },
  data() {
    return {
      /* Datos del Componente*/
      isValid: false,
      isSaving: false,
      validationSchema: {},
      m_errors: {},
      m_data: {},
      fields: { text: "name", value: "id" },
      isModal: true,
      target: document.getElementById("dialog"),
      width: this.isMobile ? "90%" : "70%",
      integrationTypes: [],
      integrationType: null,
      valueTypes: [],
      integrationFields: { text: "description", value: "id" },
      /* Grid de Parámetros*/
      gridData: [],
      gridColumns: [],
      toolTip: "",
      pageSettings: { pageCount: 5, pageSize: 10 },
      filterSettings: {
        mode: "Immediate",
        immediatemodedelay: 0,
        type: Browser.isDevice ? "Menu" : "FilterBar",
        columns: [],
        ignoreAccent: true
      },
      filter: { type: "CheckBox" },
      selectionSettings: { persistSelection: true },
      query: "",
      customAttributes: { class: "check" },
      isInGridEdition: false,
      intParams: {
        params: {
          validateDecimalOnType: false,
          decimals: 0,
          format: "N"
        }
      }
    };
  },
  created() {},
  async mounted() {
    try {
      createSpinner({
        target: this.$refs.formDialog.$el
      });
      await this.$store.dispatch("integrations/getIntegrationTypes");
      this.integrationTypes = JSON.parse(
        JSON.stringify(this.$store.getters["integrations/allIntegrationTypes"])
      );

      await this.$store.dispatch("valueTypes/getValueTypes");
      this.valueTypes = JSON.parse(
        JSON.stringify(this.$store.getters["valueTypes/allValueTypes"])
      );

      this.gridColumns = this.getGridColumns();

      this.buildYupSchema();
    } catch (error) {
      console.log(error);
    }
  },
  updated() {},
  provide: {
    grid: [Edit, Sort, Filter, Page, Selection, Toolbar, CommandColumn, Tooltip]
  },
  methods: {
    async onDialogOpen() {
      try {
        this.showSpinner();

        this.m_data = Object.assign({}, this.formData);
        this.m_data.integrationItems = [];
        if (this.formAction == FormActionEnum.ADD) {
          this.m_data.isTemplate = true;
          this.m_data.isNew = true;
          this.gridData = [];
          this.$refs.gridIntegrationItems.ej2Instances.refresh();

          //si es nuevo la lista no se setea
        }
        if (this.formAction != FormActionEnum.ADD) {
          //si es nuevo la lista no se setea
          this.m_data.isNew = false;
          //Obtener toda la información, incluyendo los datamaps.
          await this.$store.dispatch(
            "integrations/getIntegration",
            this.formData.id
          );

          var returned = Object.assign(
            {},
            this.$store.getters["integrations/currentIntegration"]
          );

          this.m_data.integrationItems = returned.integrationItems;
        }

        if (
          this.formAction == FormActionEnum.VIEW ||
          this.formAction == FormActionEnum.DELETE ||
          this.formAction == FormActionEnum.SPECIAL
        ) {
          this.$refs.gridIntegrationItems.ej2Instances.enable = false;
        } else {
          this.$refs.gridIntegrationItems.ej2Instances.enable = true;
        }

        this.hideSpinner();
      } catch (error) {
        console.log(error);
        this.hideSpinner();
      }
    },
    getGridColumns() {
      //Obtener las columnas del Grid.
      var columns = [
        {
          field: "integrationTypeItemId",
          isPrimaryKey: true,
          visible: false
        },
        {
          field: "integrationId",
          visible: false
        },
        {
          field: "valueTypeId",
          visible: false
        },
        {
          field: "itemKey",
          headerText: "Llave",
          textAlign: "Left",
          allowEditing: false
        },
        {
          field: "valueTypeName",
          headerText: "Tipo de Dato",
          textAlign: "Left",
          allowEditing: false
        },
        {
          field: "value",
          headerText: "Valor / Variable",
          textAlign: "Left",
          allowEditing: true
        },
        {
          field: "parameterCode",
          headerText: "Código de Parámetro",
          textAlign: "Left",
          allowEditing: true
        },
        {
          field: "parameterSubCode",
          headerText: "Subcódigo de Parámetro",
          textAlign: "Left",
          allowEditing: true
        },
        {
          field: "isRequired",
          headerText: "Requerido",
          textAlign: "Left",
          allowEditing: false,
          editType: "booleanedit",
          displayAsCheckBox: "true"
        },
        {
          field: "isConfigItem",
          headerText: "Es Configuracion",
          textAlign: "Left",
          allowEditing: false,
          editType: "booleanedit",
          displayAsCheckBox: "true"
        },
        {
          field: "isFixedValue",
          headerText: "Valor Fijo",
          textAlign: "Left",
          allowEditing: false,
          editType: "booleanedit",
          displayAsCheckBox: "true"
        },
        {
          field: "isParameterValue",
          headerText: "Valor Paramétrico",
          textAlign: "Left",
          allowEditing: false,
          editType: "booleanedit",
          displayAsCheckBox: "true"
        }
      ];
      return columns;
    },
    getListData() {
      var instance = this;

      var hasItems =
        this.integrationType.integrationTypeItems &&
        this.integrationType.integrationTypeItems.length > 0;

      var hasIntegrationItems =
        instance.m_data.integrationItems &&
        instance.m_data.integrationItems.length > 0;
      if (!hasItems) return [];

      var currentItems = [];
      if (hasIntegrationItems)
        currentItems = JSON.parse(
          JSON.stringify(instance.m_data.integrationItems)
        );

      var hasValueTypes = this.valueTypes && this.valueTypes.length > 0;
      if (!hasValueTypes) return [];

      if (hasItems && hasValueTypes) {
        //recuperar los IntegrationTypeItems con sus respectivos ValueTypes
        var ret = instance.integrationType.integrationTypeItems.map(function (
          item
        ) {
          var valueType = instance.valueTypes.find(
            (t) => t.id == item.valueTypeId
          );

          //Mapeamos el item sin los valores de papirus.IntegrationItems
          var returnItem = {
            integrationTypeItemId: item.id,
            itemKey: item.itemKey,
            itemDescription: item.itemDescription,
            valueTypeId: item.valueTypeId,
            valueTypeName: valueType.name,
            isConfigItem: item.isConfigItem,
            isFixedValue: item.isFixedValue,
            isParameterValue: item.isParameterValue,
            isRequired: item.isRequired,
            integrationId: 0,
            value: null,
            parameterCode: null,
            parameterSubCode: null
          };

          //Si existe el Item, entonces seteamos los valores
          if (hasIntegrationItems) {
            var existent = currentItems.find(
              (x) => x.integrationTypeItemId == item.id
            );

            if (existent != null && existent != undefined) {
              returnItem.value = existent.value;
              returnItem.parameterCode = existent.parameterCode;
              returnItem.parameterSubCode = existent.parameterSubCode;
            }
          }
          return returnItem;
        });
        return ret;
      } else {
        return [];
      }
    },
    async onDialogClose() {
      try {
        this.clearErrors();
        await this.$store.dispatch("integrations/initIntegration");
        this.m_data = Object.assign(
          {},
          this.$store.getters["integrations/currentIntegration"]
        );
        this.$emit("formClosed");
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.gridData = [];
      this.$refs.gridIntegrationItems.ej2Instances.dataSource = [];
      this.$refs.gridIntegrationItems.ej2Instances.refresh();

      setTimeout(() => {
        this.$refs.formDialog.hide();
        this.onDialogClose();
      }, 500);
    },
    showSpinner() {
      showSpinner(this.$refs.formDialog.$el);
    },
    hideSpinner() {
      hideSpinner(this.$refs.formDialog.$el);
    },
    clearErrors() {
      this.m_errors = {};
    },
    async onActionBegin(args) {
      if (args.requestType === "filtering") {
        if (args.columns && args.columns.length) {
          args.columns.forEach((col) => {
            col.operator = "contains"; // set the “contains” operator for the ‘CustomerID’ column
          });
        }
      }

      if (args.requestType === "refresh") {
        this.$refs.gridIntegrationItems.showSpinner();
      }

      if (args.action === "edit" && args.requestType === "save") {
        if (!this.validateData(args.data)) {
          args.cancel = true;
          return;
        }
        // if (this.validateData(args.data)) {
        //   await this.editclick(args.data);
        // } else {
        //   args.cancel = true;
        //   return;
        // }
      }

      // if (args.requestType === "delete") {
      //   let cancel = this.InactivateRow(args.data[0]);
      //   args.cancel = cancel;
      //   this.$refs.gridIntegrationItems.ej2Instances.refresh();
      //   return;
      // }
    },
    onActionComplete(args) {
      if (args.requestType === "refresh") {
        this.$refs.gridIntegrationItems.hideSpinner();
      }

      if (args.name == "actionComplete" && args.requestType == "beginEdit") {
        if (!args.cancel) this.isInGridEdition = true;
      }
      if (
        args.name == "actionComplete" &&
        (args.requestType == "save" || args.requestType == "cancel")
      ) {
        if (!args.cancel) this.isInGridEdition = false;
      }
      // if (args.name == "actionComplete" && args.requestType == "delete") {
      //   this.$refs.gridIntegrationItems.ej2Instances.refresh();
      // }
    },
    validateData(data) {
      var isValidData = true;
      var listaErrores = [];

      if (!data.isConfigItem) {
        if (data.isRequired && this.isnullOrWhiteSpace(data.value)) {
          listaErrores.push(
            "Debe especificar un valor para el item " +
              data.itemKey +
              ' en el campo "Valor/Variable" !'
          );
          isValidData = false;
        }
      } else if (data.isConfigItem) {
        //validar cuando es FixedValue
        if (data.isFixedValue) {
          if (data.isRequired && this.isnullOrWhiteSpace(data.value)) {
            listaErrores.push(
              "Debe especificar un valor para el item " +
                data.itemKey +
                ' en el campo "Valor/Variable" !'
            );
            isValidData = false;
          }
        } else {
          if (data.isRequired && this.isnullOrWhiteSpace(data.parameterCode)) {
            listaErrores.push(
              "Debe especificar un valor para el item " +
                data.itemKey +
                ' en el campo "Código de Parámetro" !'
            );
            isValidData = false;
          }

          if (
            data.isRequired &&
            this.isnullOrWhiteSpace(data.parameterSubCode)
          ) {
            listaErrores.push(
              "Debe especificar un valor para el item " +
                data.itemKey +
                ' en el campo "Subcódigo de Parámetro" !'
            );
            isValidData = false;
          }
        }
      }

      if (!isValidData) {
        var _validaciones = listaErrores.join("<br/>");
        Vue.set(this.m_errors, "listaIntegrationItems", _validaciones);
        this.showToast(
          "Validacion faliida",
          "Por favor verifique los errores listados en la parte inferior de los parámetros de integración!",
          2000
        );
      }

      return isValidData;
      //return this.validateDuplicate(data);
    },
    isnullOrWhiteSpace(string) {
      return (
        string === null || string === undefined || string.trim().length == 0
      );
    },
    async toolbar_click() {},
    // async editclick(data) {
    //   try {
    //     console.log(data);
    //     console.log(this.gridData);
    //   } catch (error) {
    //     this.showToast(
    //       "Error!",
    //       "Ocurrió un error al ejecutar la operación",
    //       2000
    //     );
    //   }
    // },
    InactivateRow(data) {
      var instance = this;

      var dItems = JSON.parse(JSON.stringify(instance.m_data.integrationItems));
      var hasData = dItems && dItems.length > 0;
      if (!hasData) return [];

      var localData = JSON.parse(JSON.stringify(data));
      // //this.gridData.splice(this.gridData.indexOf(localData));
      var existent = dItems.find(
        (x) =>
          x.documentId == localData.documentId &&
          x.formatId == localData.formatId
      );
      let cancel = existent != undefined && existent != null;

      data.isActive = false;
      existent = this.gridData.find(
        (x) =>
          x.documentId == localData.documentId &&
          x.formatId == localData.formatId
      );

      var delIndex = this.gridData.indexOf(existent);
      this.$set(this.gridData, delIndex, data);
      return cancel;
    },
    getItems() {
      var instance = this;
      return this.gridData.map(function (item) {
        return {
          integrationId: instance.m_data.id,
          integrationTypeItemId: item.integrationTypeItemId,
          value: item.value,
          parameterCode: item.parameterCode,
          parameterSubCode: item.parameterSubCode
        };
      });
    },
    async saveData() {
      try {
        this.isSaving = true;

        this.m_data.integrationItems = this.getItems();
        switch (this.formAction) {
          case FormActionEnum.VIEW:
            this.showToast(
              "No habilitado",
              "Modo consulta, nada para grabar!",
              2000
            );
            break;
          case FormActionEnum.ADD:
            this.m_data.isActive = true;
            await this.$store.dispatch(
              "integrations/createIntegration",
              this.m_data
            );
            this.showToast("Confirmación", "Registro Creado!", 2000);
            this.$emit("onDataChange");
            break;
          case FormActionEnum.EDIT:
            await this.$store.dispatch(
              "integrations/updateIntegration",
              JSON.parse(JSON.stringify(this.m_data))
            );
            this.showToast("Confirmación", "Registro Actualizado", 2000);
            this.$emit("onDataChange");
            break;
        }
        //await this.$store.dispatch("integrations/getIntegrations");
        /* esperar medio segundo antes de cerrar */
        setTimeout(() => {
          this.isSaving = false;
          this.hideSpinner();
          this.close();
        }, 500);
      } catch (error) {
        this.isSaving = false;
        this.hideSpinner();
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
    },
    buildYupSchema() {
      this.validationSchema = Yup.object().shape({
        isNew: Yup.boolean(),
        isActive: Yup.boolean(),
        integrationTypeId: Yup.number()
          .nullable()
          .required()
          .label("Tipo de Integración")
          .typeError("Seleccione Tipo de Integración"),
        name: Yup.string().required().max(100).label("Integración"),
        description: Yup.string()
          .required()
          .max(512)
          .label("Descripción Integración")
      });
    },
    hasError(field) {
      return !!this.m_errors[field];
    },
    async onIntegrationChange(args) {
      //Obtener los
      await this.validateField("integrationTypeId");

      if (args.item == null) {
        this.m_data.isEmail = false;
        this.m_data.isFileSystem = false;
        this.m_data.isSftp = false;
        this.m_data.isS3Compatible = false;
      } else {
        this.m_data.isEmail = args.itemData.isEmail;
        this.m_data.isFileSystem = args.itemData.isFileSystem;
        this.m_data.isSftp = args.itemData.isSftp;
        this.m_data.isS3Compatible = args.itemData.isS3Compatible;

        this.integrationType = await this.$store.dispatch(
          "integrations/getIntegrationType",
          { id: args.item.id, returnData: true }
        );
      }
      var gridData = this.getListData();
      if (gridData == undefined) this.gridData = [];
      else this.gridData = gridData;
      this.$refs.gridIntegrationItems.ej2Instances.refresh();
      this.$refs.gridIntegrationItems.ej2Instances.autoFitColumns();
    },
    async validateField(field) {
      Vue.set(this.m_errors, field, "");

      if (this.isFormReadOnly) return;

      this.validationSchema.validateAt(field, this.m_data).catch((err) => {
        Vue.set(this.m_errors, err.path, err.message);
      });
    },
    async validateForm() {
      var instance = this;
      try {
        await this.validationSchema.validate(this.m_data, {
          abortEarly: false
        });

        var hasData = this.gridData && this.gridData.length > 0;

        if (!hasData) {
          Vue.set(
            this.m_errors,
            "listaIntegrationItems",
            "Debe Seleccionar al menos un Item de Configuración!"
          );
          return;
        }

        if (this.isInGridEdition) {
          this.showToast(
            "Validación!",
            "Debe Aceptar los cambios en los Parámetros antes de continuar",
            2000
          );
          return;
        }

        var isValid = true;
        this.gridData.some(function (item) {
          var itemValid = instance.validateData(item);
          if (!itemValid) {
            isValid = false;
            return true;
          }
        });
        if (!isValid) return;

        this.m_errors = {};
        await this.saveData();
      } catch (error) {
        if (error.inner != undefined) {
          error.inner.forEach((error) => {
            Vue.set(this.m_errors, error.path, error.message);
          });
        } else {
          this.showToast("Error en Validación!", error.message, 2000);
        }
      }
    }
  },
  props: {
    /** Whether the dialog is currently showing */
    showing: {
      type: Boolean,
      required: true,
      default: false
    },
    formAction: {
      type: Number,
      required: true,
      default: 0
    },
    isMobile: {
      type: Boolean,
      required: true,
      default: false
    },
    formData: {
      type: Object,
      required: false,
      default() {
        return {
          id: 0,
          name: "",
          useCustomNaming: false,
          namingSQLQuery: "",
          namingTemplate: "",
          onePdfPerPage: false,
          previewEnabled: false,
          isActive: false
        };
      }
    }
  }
});
</script>

<style scoped>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-dropdowns/styles/fabric.css);
@import url(../form-icons.css);

/* div {
  border: 1px solid #eee;
} */

.classEspecial {
  align-self: center;
}

.dialog-papirus.e-dialog .e-dlg-header {
  color: #0078d6;
  font-size: 20px;
  font-weight: normal;
}

.content-wrapper div.row {
  padding: 5px 0px;
}

.switch-label {
  padding: 0px 0px 0px 20px;
  margin: auto;
  cursor: pointer;
}

.e-save.e-icons:before,
.e-save.e-icons:before {
  content: "\e609";
}

.e-add.e-icons:before,
.e-add.e-icons:before {
  content: "\e7d5";
}

@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }

  .e-input-section .col-xs-6,
  .e-input-section .col-xs-4,
  .e-input-section .col-xs-12 {
    padding: 10px 5px;
    width: 100%;
  }

  .content-wrapper div.row {
    padding: 0px;
  }
}
</style>
